
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 15.428A6.286 6.286 0 108 2.857a6.286 6.286 0 000 12.571zM6.285.571h3.429M8 .571v2.286","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.285 6.857L8 9.143h2.858M13.715 2.286l1.143 1.143M2.285 2.286L1.143 3.429","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    